

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BedParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Bed {
    id?: number;
     bedNo:string; 
     bedType:string;
     otRent:any;
     otTheatreId:any;
     roomId:any;
     floorId:any;
     nursingCounterId:any
      isActive:string;
     buildingId:any;
    tenantId: any;
    branchId: any;
    bedStatus:any;
    wardId:any;
    room?:any;
    building?:any;
   floor?:any;
    nursingCounter?:any;
  parameters?: BedParameter[];
  links?: any;
}

export abstract class BedData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<any>;
  abstract create(url: string, data: Bed): Observable<Bed[]>;
  abstract update(url: string, data: Bed): Observable<Bed>;
  abstract delete(url: string): Observable<any>;
  abstract search(url: string, data: any): Observable<any>;

}
